import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FileInfo, FileSelectComponent, RemoveEvent, SelectEvent } from '@progress/kendo-angular-upload';
import { Base64File } from '../models/base-64-file';
import { FieldConfig } from '../models/dynamic-form-field';

@Component({
  selector: 'app-dynamic-file-select',
  templateUrl: './dynamic-file-select.component.html',
  styleUrls: ['./dynamic-file-select.component.scss']
})
export class DynamicFileSelectComponent implements OnInit {
  @ViewChild(FileSelectComponent) fileSelectComponent;

  field: FieldConfig;
  group: FormGroup;

  files: Base64File[] = [];
  constructor() { }

  ngOnInit() {
    this.updateFormControl();
  }

  updateFormControl() {

    const formControl = this.group.controls[this.field.name];
    formControl.valid
    formControl.setValue(this.files);
    formControl.updateValueAndValidity();
  }

  async filesSelected(event: SelectEvent) {
    const newFiles = await this.tobase64Handler(event.files);
    this.files.push(...newFiles);
    this.updateFormControl();
  }

  fileRemoved(event: RemoveEvent) {
    event.files.forEach(f => {
      const index = this.files.findIndex(fi => fi.uid === f.uid);
      if (index >= 0) {
        this.files.splice(index, 1);
      }
    });
    this.updateFormControl();
  }

  toBase64(file: FileInfo): Promise<Base64File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.rawFile);
      reader.onload = () => resolve({
        extension: file.extension,
        name: file.name,
        size: file.size,
        uid: file.uid,
        base64: (reader.result as string).split(',')[1],
        validationErrors: file.validationErrors || []
      });
      reader.onerror = error => reject(error);
    });
  };

  async tobase64Handler(files: FileInfo[]) {
    const filePathsPromises: Promise<Base64File>[] = [];
    files.forEach(file => {
      filePathsPromises.push(this.toBase64(file));
    });

    return await Promise.all(filePathsPromises);
  }

  reset() {
    this.fileSelectComponent.clearFiles();
  }

}
